import React from 'react';
import Typography from '@mui/material/Typography';
import { openUrlAndDownload } from '../helpers';
import InvoiceUploadedDocumentActions from '../components/attach/InvoiceUploadedDocumentActions';

const getInvoiceUploadedDocumentsColumns = ({ handleOpenInput }) => [
  {
    field: 'label',
    headerName: 'Documento',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) => (
      <Typography variant="medium_1" color="gray.A700">
        {row.label}
      </Typography>
    ),
  },
  {
    field: 'actions',
    headerName: 'Acciones',
    width: 220,
    headerAlign: 'left',
    align: 'left',
    sortable: false,
    renderCell: ({ row }) => (
      <InvoiceUploadedDocumentActions
        documentKey={row.uploadDocumentType || row.id}
        documentUrl={row.documentUrl}
        disableUpload={row.disableUpload}
        uploadTooltip={row.uploadTooltip}
        isUploading={row.isUploading}
        onDownload={() => row.documentUrl && openUrlAndDownload(row.documentUrl)}
        onUpload={() => handleOpenInput({ documentType: row.uploadDocumentType })}
      />
    ),
  },
];

export default getInvoiceUploadedDocumentsColumns;
